import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { FaCheck, FaChevronDown, FaChevronUp } from "react-icons/fa"

import { LANGUAGE_STORAGE_KEY, languages } from "@/utils/i18n"
import { join } from "@/utils/join"
import { usePopUpMenu } from "@/utils/usePopUpMenu"

const displayLanguages = languages.map((lang) => lang.toUpperCase())

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation()

  const ref = useRef<HTMLDivElement>(null)
  const [displayMenu, setDisplayMenu] = usePopUpMenu(ref)
  const selected = i18n.language.toUpperCase()

  const handleSelection = (lang: string) => {
    const langCode = lang.toLowerCase()
    void i18n.changeLanguage(langCode)
    localStorage.setItem(LANGUAGE_STORAGE_KEY, langCode)
  }

  return (
    <div
      className="relative flex cursor-pointer items-center px-xs display-xs-regular leading-[0] text-secondary transition-all duration-200 ease-in-out"
      onClick={() => setDisplayMenu(!displayMenu)}
    >
      <div>{selected}</div>
      <div>
        {displayMenu ? (
          <FaChevronUp className="relative ml-sm text-[12px] text-quaternary_on-brand" />
        ) : (
          <FaChevronDown className="relative ml-sm text-[12px] text-quaternary_on-brand" />
        )}
      </div>
      {displayMenu && (
        <div
          className="absolute top-[30px] right-0 z-30 w-[140px] rounded-sm bg-tertiary shadow-lg shadow-(color:--bg-primary)"
          ref={ref}
        >
          {displayLanguages.map((option) => (
            <div
              className={join(
                selected === option ? "text-brand-primary" : "inherit",
                "flex h-(--density-md) items-center justify-between rounded-sm px-2xl py-3xl hover:bg-quaternary",
              )}
              key={option}
              onClick={() => handleSelection(option)}
            >
              {option}
              {selected === option && (
                <FaCheck className="relative ml-xl text-[12px] text-quaternary_on-brand" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
